export default {
  blockType: 'accordian',
  items: [
    {
      trigger: 'Direct Ownership of Digital Assets',
      content: 'Maintain sovereign ownership of your digital assets with the security and transparency of blockchain technology.',
    },
    {
      trigger: 'Easy Asset Management',
      content: 'Manage, trade, and convert your digital assets effortlessly with the intuitive Lux Card interface.',
    },
    {
      trigger: 'Lux Standard Guaranteed Backing',
      content: 'Each transaction and asset held on the Lux Card is backed by the Lux Standard, ensuring a trustworthy and reliable experience.',
    },
    {
      trigger: 'Enhanced Security',
      content: 'Experience peace of mind with advanced security features ensuring the safety of your assets.',
    },
    {
      trigger: 'DAO membership included',
      content: 'Automatically become a member of the Lux Network decentralized governance organization.'
    },
  ]
}